export default __webpack_public_path__ + "static/media/banner3.a4c84051.jpg";